<div class="avatar-product-container">
    <ngx-skeleton-loader count="1" appearance="circle" [hidden]="!loading"
        [theme]="{ width: '2.5em', height: '2.5em', position: 'relative', bottom: '0.45em'}">
    </ngx-skeleton-loader>
    <img [hidden]="loading" (load)="onLoad()" (error)="onError()" class="avatar" [src]="getImage()" alt="media">
</div>
